import type { RescheduleActivityRequestProps } from "Api/activity/types";
import { getBaseUrl } from "Api/utils";
import { request } from "Libs/platform";

export const rescheduleActivityRequest = ({
  activity,
  scheduled_at
}: RescheduleActivityRequestProps) => {
  const rescheduleLink = activity?._links?.["#reschedule"]?.href;
  if (!rescheduleLink) {
    throw new Error("Activity does not have a #reschedule link");
  }

  const baseUrl = getBaseUrl(activity?._links?.self?.href || "");

  let path = rescheduleLink;

  if (baseUrl.endsWith("/") && rescheduleLink.startsWith("/")) {
    path = rescheduleLink.substring(1);
  }
  return request(baseUrl + path, "POST", { scheduled_at });
};
